import { BrandStatus } from "constants/brandStatus";
import { privateApi, publicApi } from "../utilities/Provider";

const basicUrl = "/Kitchen/";

const addKitchen = (model, clientId, redirectUri) => {
  let body = {
    kitchenInfoRequest: {
      name: model.name,
      businessAddress: model.address,
      addressLine1: model.addressLine1,
      city: model.city,
      state: model.state,
      postalCode: model.postalCode,
      country: model.country,
      latitude: model.latitude,
      longitude: model.longitude,
      listedPhoneNumber: model.listedPhoneNumber || model.phone,
    },
    userInfoRequest: {
      contactName: model.contactName,
      phoneNumber: "" + model.phone,
      emailAddress: model.email,
      password: model.password,
      confirmPassword: model.password,
    },
  };
  return publicApi.post(basicUrl + "kitchen", body);
};

const getKitchens = ({ pageSize, pageNum, searchTerm }) => {
  const params = new URLSearchParams();
  params.append("pageNum", pageNum);
  params.append("pageSize", pageSize);
  if (searchTerm) params.append("name", searchTerm);
  return privateApi.get(basicUrl + "kitchenlisting", { params });
};

const editKitchen = (model) => {
  let body = {
    kitchenInfoRequest: {
      id: model.id,
      name: model.businessName,
      businessAddress: model.businessAddress,
      addressLine1: model.addressLine1,
      city: model.city,
      state: model.state,
      postalCode: model.postalCode,
      country: model.country,
      latitude: model.latitude,
      longitude: model.longitude,
      salesTaxIndicator: model.salesTaxIndicator,
      callRestaurantEnabled: model.callRestaurantEnabled,
      listedPhoneNumber: model.listedPhoneNumber || model.phone,
      reportEmails: model.emails.map((item) => item.value).filter(email => email && email.trim() !== ""),
    },
    userInfoRequest: {
      id: model.ownerId,
      contactName: model.contactName,
      phoneNumber: "" + model.phone,
      emailAddress: model.email,
    },
  };

  return privateApi.put(basicUrl + "kitchen", body);
};

const deleteKitchen = (kitchenId) => {
  return privateApi.delete(basicUrl + "kitchen", {
    params: {
      id: kitchenId,
    },
  });
};

const getKitchenById = (kitchenId) => {
  return privateApi.get(basicUrl + "kitchen", {
    params: {
      id: kitchenId,
    },
  });
};

const getVBListByKitchenId = (model) => {
  return privateApi.get(basicUrl + "kitchenVBList", {
    params: {
      id: model.kitchenId,
      pageNum: model.pageNum,
      pageSize: model.pageSize
    },
  });
};

const getDeviceListByKitchenId = (model) => {
  return privateApi.get(basicUrl + "kitchenDeviceList", {
    params: {
      id: model.kitchenId,
      pageNum: model.pageNum,
      pageSize: model.pageSize
    },
  });
};

const changeKitchenStatus = (kitchenId, statusId) => {
  let body = {
    kitchenId: kitchenId,
    statusId: statusId,
  };
  return privateApi.put(basicUrl + "updatekitchenstatus", body);
};

const getActiveKitchens = (searchTerm = null) => {
  const params = new URLSearchParams();
  if (searchTerm) params.append("name", searchTerm);

  return privateApi.get(basicUrl + "allactivekitchens", { params });
};

const addVbToKitchen = (brandId, kitchenId) => {
  let body = {
    virtualBrandId: brandId,
    kitchenId: kitchenId,
    statusId: BrandStatus.DRAFT,
  };
  return privateApi.put(basicUrl + "addvbtokitchen", body);
};

const addKitchenMarketPlaces = (model, type) => {
  let body = {
    kitchenId: model.kitchenId,
    kitchenName: model.kitchenName,
    userId: model.userId,
    Marketplaces: model.options.map((opt) => ({
      MarketplaceId: opt.id,
      IsRestricted: opt.isRestricted,
      name: opt.name
    })),
  };
  if (type === "delivery") {
    return privateApi.post(basicUrl + "addmarketplacesfordelivery", body);
  } else if (type === "payout") {
    return privateApi.post(basicUrl + "addmarketplacesforpayout", body);
  }
};

const getKitchenMarketplaces = (kitchenId, type) => {
  if (type === "delivery") {
    return privateApi.get(basicUrl + "marketplacelistfordelivery", {
      params: {
        kitchenId: kitchenId,
      },
    });
  } else if (type === "payout") {
    return privateApi.get(basicUrl + "marketplacelistforpayout", {
      params: {
        kitchenId: kitchenId,
      },
    });
  }
};

const addKitchenMarketPlaceMarkup = (model, type) => {
  let body = {
    kitchenId: model.kitchenId,
    kitchenName: model.kitchenName,
    userId: model.userId,
    Marketplaces: model.options.map((opt) => ({
      MarketplaceId: opt.marketplaceId,
      IsEnabled: opt.isEnabled,
      name: opt.name,
      markupValue: opt.markupValue,
      markupType: opt.markupType
    })),
  };
  return privateApi.post(basicUrl + "addmarkupformarketplaces", body);
};

const getKitchenMarketplaceMarkupList = (kitchenId) => {
  return privateApi.get(basicUrl + "marketplacemarkuplist", {
    params: {
      kitchenId: kitchenId,
    },
  });
};

const getIntegrationsDropdownList = () => {
  return privateApi.get(basicUrl + "integrationlist");
};

const getKitchenIntegrationData = (kitchenId) => {
  const params = new URLSearchParams();
  if (kitchenId) params.append("id", kitchenId);
  return privateApi.get(basicUrl + "kitchenintegration", { params });
};

const updateKitchenIntegration = (model) => {
  let body = {
    id: model?.providerId,
    type: model?.deviceType,
    kitchenId: model?.kitchenId,
    userId: model?.userId
  };
  return privateApi.put(basicUrl + "updatekitchenintegration", body);
};

const pauseRestaurant = (model) => {
  let body = {
    kitchenId: model?.kitchenId,
    isPaused: model?.isPaused,
    pausedUntil: model?.pausedUntil,
    reason: model?.reason,
  };
  return privateApi.put(basicUrl + "pause", body);
};

const getRestaurantStatus = (kitchenId) => {
  const params = new URLSearchParams();
  if (kitchenId) params.append("kitchenId", kitchenId);
  return privateApi.get(basicUrl + "status", { params });
};

const addKitchenFees = (model) => {
  let body = {
    kitchenId: model.kitchenId,
    marketingFee: model.marketingFee,
    softwareFee: model.softwareFee,
  };
  return privateApi.post(basicUrl + "fees", body);
};

const getKitchenFees = (kitchenId) => {
  const params = new URLSearchParams();
  if (kitchenId) params.append("kitchenId", kitchenId);
  return privateApi.get(basicUrl + "fees", { params });
};

export {
  addKitchen,
  editKitchen,
  getKitchens,
  getKitchenById,
  deleteKitchen,
  changeKitchenStatus,
  getActiveKitchens,
  addVbToKitchen,
  getVBListByKitchenId,
  getDeviceListByKitchenId,
  addKitchenMarketPlaces,
  getKitchenMarketplaces,
  getKitchenMarketplaceMarkupList,
  addKitchenMarketPlaceMarkup,
  getIntegrationsDropdownList,
  updateKitchenIntegration,
  getKitchenIntegrationData,
  pauseRestaurant,
  getRestaurantStatus,
  addKitchenFees,
  getKitchenFees
};
